<template>
  <div>
    <div class="page-header-wrapper">
      <PageHeader id="Basic" title="Basic" />
    </div>
    <div class="basic-info table-wrapper" v-loading="infoLoading" element-loading-text="Loading...">
      <div class="avatar-info">
        <div class="avatar-name">
          <el-avatar shape="square" size="large" :src="AvatarURL" />
          <div class="name-status">
            <h3>{{ info.SEName }}</h3>
            <div>
              <el-tag size="mini" effect="dark" :type="tagType" style="margin-right: 5px;">
                {{ tagLabel }}
              </el-tag>
              <template v-if="info.Types">
                <el-tag size="mini" effect="dark" type="info"  v-for="(item,i) in info.Types.split('/')" :key="i">
                  {{ item }}
                </el-tag>
              </template>
            </div>
          </div>
        </div>
        <div class="actions">
          <el-button size="mini" icon="iconfont icon-qrcode" @click="getQRCode">
            QR Code
          </el-button>
          <el-button size="mini" icon="el-icon-plus" type="primary" :disabled="disabled"
            @click="combinePushDialogVisible = true">
            New Push
          </el-button>
        </div>
      </div>
      <div class="focus-area">
        <h4>Engagement Profile </h4>
        <el-input maxlength="500" show-limit-number type="textarea" v-model="focus" :rows="3" />
        <div class="actions">
          <el-button size="mini" @click="resetFocus">Reset</el-button>
          <el-button size="mini" type="danger" plain @click="setFocus">
            Save
          </el-button>
        </div>
      </div>
      <div class="profile-detail">
        <div>
          <strong>Province</strong>
          <p>
            <span :title="info.Province" v-text="info.Province"></span>
          </p>
        </div>
        <div>
          <strong>City</strong>
          <p>
            <span :title="info.City" v-text="info.City"></span>
          </p>
        </div>
        <div>
          <strong>Hospital / Institution</strong>
          <p>
            <span :title="info.Hospital" v-text="info.Hospital"></span>
          </p>
        </div>
        <div>
          <strong>Department</strong>
          <p>
            <span :title="info.Department" v-text="info.Department"></span>
          </p>
        </div>
        <div>
          <!-- <strong>{{ isVCE ? 'Phone' : 'Certified' }}</strong> -->
          <!-- <p v-if="isVCE"> -->
          <strong>Phone</strong>
          <p>
            <span v-if="!editingPhone">
              <span :title="info.Phone" v-text="info.Phone"></span>
              <i class="el-icon-edit-outline" v-if="!canNotEditPhone" @click="editPhone"
                style="color: #409eff;cursor: pointer;">Edit</i>
            </span>
            <span v-else class="edit-input">
              <el-input v-model="info.Phone" placeholder="Input phone"></el-input>
              <el-button size="mini" type="primary" plain @click="savePhone" :loading="editPhoneLoading">
                Save
              </el-button>
            </span>
          </p>
          <!-- <p v-else>
            <span v-text="info.Active !== 0" style="text-transform: capitalize"></span>
          </p> -->
        </div>
        <!-- <div>
          <strong>{{isVCE?'Phone':'Certified'}}</strong>
          <p v-if="isVCE">
            <span :title="info.Phone" v-text="info.Phone"></span>
          </p>
          <p v-else>
            <span v-text="info.Active !== 0" style="text-transform: capitalize"></span>
          </p>
        </div> -->
      </div>
    </div>
    <div class="table-wrapper el-collapse-wrapper">
      <el-collapse v-model="collapse">
        <el-collapse-item name="PushedContent">
          <template slot="title">
            <PageHeader id="PushedContent" title="Pushed Content" />
          </template>
          <PushedContent ref="pushedContent" class="padding-lr" />
        </el-collapse-item>
        <el-collapse-item name="TextMessage">
          <template slot="title">
            <PageHeader id="TextMessage" title="Messages" />
          </template>
          <TextMessage ref="textMessage" class="padding-lr" />
        </el-collapse-item>
        <el-collapse-item name="PaperComments">
          <template slot="title">
            <PageHeader id="PaperComments" title="Paper Comments" />
          </template>
          <PaperComments ref="paperComments" class="padding-lr" />
        </el-collapse-item>
        <el-collapse-item name="FullArticleRequests">
          <template slot="title">
            <PageHeader id="FullArticleRequests" title="Full Article Requests" />
          </template>
          <FullArticleRequests ref="fullArticleRequests" class="padding-lr" />
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <PageHeader title="Certification" />
          </template>
          <Certification ref="cert" class="padding-lr" @success="onSuccess" />
        </el-collapse-item>
      </el-collapse>
    </div>
    <CombinePushDialog :visible.sync="combinePushDialogVisible" @success="onSuccess" :data.sync="rowData"/>
    <NewPushDialog :visible.sync="newPushDialogVisible" :seId.sync="info.SEID" @success="onSuccess" />
    <QRCodeDialog :title="title" :visible.sync="qrcodeDialogVisible" :data.sync="rowData" />
  </div>
</template>

<script>
import QRCodeDialog from "../qrcode-dialog";
import PushedContent from "./pushed-content";
import TextMessage from "./text-message";
import PaperComments from "./paper-comments";
import FullArticleRequests from "./full-article-requests";
import Certification from "./certification";
import NewPushDialog from "../../push/new-push-dialog";
import CombinePushDialog from "../../push/combine-push/combine-push-dialog.vue";
import { RoleCode } from "../../../utils/role-constant";

export default {
  name: "My-SE-View",
  components: {
    PushedContent,
    TextMessage,
    PaperComments,
    FullArticleRequests,
    Certification,
    QRCodeDialog,
    NewPushDialog,
    CombinePushDialog,
  },
  data() {
    return {
      info: {
        Active: 0,
        City: "",
        Department: "",
        Focus: "",
        Hospital: "",
        SEID: "",
        SEName: "",
        SENo: "",
      },
      focusCache: "",
      focus: "",
      newPushDialogVisible: false,
      qrcodeDialogVisible: false,
      rowData: null,
      infoLoading: false,
      infoNotFound: false,
      collapse: [],
      activeCollapse: "",
      editingPhone: false,
      editPhoneLoading: false,
    };
  },
  computed: {
    title() {
      return this.$route.path.indexOf("customer") > -1 ? "Customer" : "SE/CE"
    },
    path() {
      return this.$route.path;
    },
    AvatarURL() {
      return require("../../../assets/img/avatar.png");
    },
    disabled() {
      return this.info.Active === 0;
    },
    tagLabel() {
      return this.info.Active === 0 ? "Not Active" : "Active";
    },
    tagType() {
      return this.info.Active === 0 ? "danger" : "success";
    },
    seId() {
      return this.$route.params.seId;
    },
    hash() {
      return this.$route.hash ? this.$route.hash.substring(1) : "";
    },
    isNotBasic() {
      return this.hash !== "Basic";
    },
    role() {
      return this.$store.state.role;
    },
    isVMSL() {
      return this.role === RoleCode.VMSL;
    },
    isVCE() {
      return this.role === RoleCode.VCE;
    },
    canNotEditPhone() {
      return this.role === RoleCode.CRP || this.role === RoleCode.CVEO || this.role === RoleCode.ClinTrans || this.role === RoleCode.SciCom;
    },
  },
  watch: {
    $route(to) {
      if (to.name === "My-SE/CE-View" && this.info.SEID === this.seId) {
        this.$nextTick(() => {
          this.handleCollapseChange();
          if (this.activeCollapse !== this.hash) {
            this.qrcodeDialogVisible = false;
            this.newPushDialogVisible = false;
            if (this.$refs.pushedContent) {
              this.$refs.pushedContent.closeDialog();
            }
            this.scrollTo();
          }
          if (this.isNotBasic) {
            this.activeCollapse = this.hash || this.activeCollapse;
          }
        });
      }
    },
  },
  created() {
    this.bus.$on("refresh", ({ name }) => {
      if (
        /^My-((SE\/CE)|Customer)-View$/.test(name) &&
        (this.info.SEID === "" || this.info.SEID === this.seId)
      ) {
        this.refresh();
      }
    });
    this.getInfo();
    if (this.hash !== "" && this.isNotBasic) {
      this.collapse = [this.hash];
      this.activeCollapse = this.hash;
    }
  },
  methods: {
    editPhone() {
      this.editingPhone = true
    },
    savePhone() {
      const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/;
      let phoneValue = this.info.Phone
      if (Number.isInteger(phoneValue) || phoneReg.test(phoneValue) || phoneValue === '') {
        this.editPhoneLoading = true
        this.axios.post("/seDetail/updatePhoneInfo", {
          SEID: this.seId,
          Phone: this.info.Phone,
        }).then(({ code, msg }) => {
          this.editPhoneLoading = false
          if (code === 200) {
            this.$message.success("Save phone successfully");
            this.editingPhone = false
          } else {
            this.$message.error(msg)
          }
        })
      } else {
        this.$message.error(
          "Phone format error, please re-ente"
        );
        this.editPhoneLoading = false
        return;
      }
    },
    scrollTo() {
      let hash = this.hash === "" ? "Basic" : this.hash;
      const appScrollbar = document.querySelector(".app>.el-scrollbar__wrap");
      const target = document.querySelector(`#${hash}`);
      if (target) {
        appScrollbar.scrollTop = target.offsetTop - 19;
      }
    },
    handleCollapseChange() {
      if (this.hash !== "" && !this.isNotBasic) {
        return;
      }
      const isExist = this.collapse.some((hash) => hash === this.hash);
      if (!isExist && this.hash) {
        this.collapse.push(this.hash);
      }
    },
    refresh() {
      this.getInfo();
      this.$refs.pushedContent.getTableData();
      this.$refs.textMessage.getTableData();
      this.$refs.paperComments.getTableData();
      this.$refs.fullArticleRequests.getTableData();
      this.$refs.cert.getTableData();
    },
    getInfo() {
      if (!this.seId) {
        return;
      }
      this.infoLoading = true;
      this.axios
        .get("/seDetail/viewInfo", {
          params: {
            seId: this.seId,
          },
        })
        .then(({ code, msg, data }) => {
          if (code === 200) {
            if (data) {
              this.info = data;
              this.focus = data.Focus;
              this.focusCache = data.Focus;
              this.bus.$emit("setTabTitle", {
                path: this.path,
                title: data.SEName,
              });
            } else {
              this.$alert("The se information is not found.", "Tips", {
                confirmButtonText: "Return SE/CE List Page",
                callback: () => {
                  const path = this.path;
                  this.$router.push("/se").then(() => {
                    this.bus.$emit("closeTab", {
                      path: path,
                    });
                  });
                },
              });
            }
          } else {
            this.$message.error(msg);
          }
          this.infoLoading = false;
        });
    },
    resetFocus() {
      this.focus = this.focusCache;
    },
    setFocus() {
      this.axios
        .post("/seDetail/setFocus", {
          seId: this.seId,
          focus: this.focus,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$message.success("Save successfully");
            this.focusCache = this.focus;
          } else {
            this.$message.error(msg);
          }
        });
    },
    getQRCode() {
      this.rowData = {
        SEID: this.info.SEID,
        SEName: this.info.SEName,
        SENo: this.info.SENo,
      };
      this.qrcodeDialogVisible = true;
    },
    onSuccess() {
      this.getInfo();
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seId) next();
    else next("/se");
  },
};
</script>

<style lang="scss" scoped>
.basic-info {
  display: flex;

  &>div {
    min-width: 250px;
    height: 136px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  .avatar-info {
    min-width: 300px;
    width: 300px;
    padding: 25px 15px 15px;
    background-color: #f9fafc;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 15px;

    .avatar-name {
      display: flex;
      align-items: center;
    }

    .name-status {
      margin-left: 15px;

      h3 {
        margin-bottom: 5px;
      }

      .el-tag {
        height: 18px;
        line-height: 16px;
      }
    }

    .actions {
      display: flex;

      .el-button {
        width: 100%;
      }

      margin-top: 25px;
    }
  }

  .focus-area {
    flex: 1;
    padding: 5px 10px;
    margin-right: 15px;
    display: flex;
    flex-direction: column;

    h4 {
      line-height: 25px;
    }

    .el-textarea {
      flex: 1;

      ::v-deep textarea {
        min-height: 66px !important;
        max-height: 66px !important;
      }
    }

    .actions {
      margin-top: 5px;
      text-align: right;
    }
  }

  .profile-detail {
    min-width: 120px;
    width: 100%;
    max-width: 400px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center; 
    overflow: hidden;

    div {
      padding: 0 1.5%;
      height: 25px;
      line-height: 1.25;
      display: flex;

      &:nth-child(2n) {
        background-color: #f9fafc;
      }

      strong {
        display: inline-block;
        width: 140px;
        border-right: 1px solid rgba(213, 43, 30, 0.5);
        margin-right: 15px;
      }

      p {
        flex: 1;
        width: 0;
        overflow: hidden;
        text-overflow: ellipsis;

        span {
          height: 25px;
          display: inline;
          white-space: nowrap;
        }
      }
    }
  }
}

.el-collapse-wrapper {
  padding: 15px 15px 15px 10px !important;
  margin-top: 15px;

  .padding-lr {
    padding-top: 10px;
  }

  ::v-deep {
    .el-table {
      min-height: auto !important;
    }

    .el-collapse-item__header.is-active {
      border-top: 1px solid rgba(213, 43, 30, 0.3);
      background-color: rgba(213, 43, 30, 0.05);
    }

    .el-collapse-item__arrow.el-icon-arrow-right {
      &.is-active {
        background: #d52b1e;
        color: #fff;
      }

      padding: 1px;
      border-radius: 100%;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
    }
  }

  .el-collapse-item:last-child {
    ::v-deep .el-collapse-item__wrap {
      border: none;
    }
  }
}
</style>
